/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Bulksenddeal3Inputs */

const en_coinvestments_outreach_bulksenddeal3 = /** @type {(inputs: Coinvestments_Outreach_Bulksenddeal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Deal`)
};

/**
* | output |
* | --- |
* | "Send Deal" |
*
* @param {Coinvestments_Outreach_Bulksenddeal3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_bulksenddeal3 = /** @type {((inputs?: Coinvestments_Outreach_Bulksenddeal3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Bulksenddeal3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_bulksenddeal3(inputs)
});
export { coinvestments_outreach_bulksenddeal3 as "coInvestments_outreach_bulkSendDeal" }